export default {
    data() {
        return {
            currentSlideNumber: 1,
            timerWidthClass: '',
            duration: 7500,
            slideInterval: null,
        }
    },
    mounted() {
        this.resetSlide();
    },
    methods: {
        resetSlide() {
            this.timerWidthClass = '';
            setTimeout(() => {
                this.timerWidthClass = '!w-full';
            }, 50);

            if (this.slideInterval) {
                clearInterval(this.slideInterval);
            }

            this.slideInterval = setInterval(() => {
                if (this.slides[this.currentSlideNumber]) {
                    this.setCurrentSlideNumber(this.currentSlideNumber + 1)
                } else {
                    this.setCurrentSlideNumber(1);
                }
            }, this.duration);
        },
        setCurrentSlideNumber(slideNumber) {
            this.currentSlideNumber = slideNumber;
        }
    },
    computed: {
        currentSlide() {
            return this.slides && this.slides[this.currentSlideNumber - 1];
        },
        durationCssString() {
            return `${this.duration}ms`
        },
    },
    watch: {
        slides() {
            this.resetSlide();
        },

        currentSlideNumber() {
            this.resetSlide();
        }
    }
}
